import React from "react";
import LegalLayout from "@/components/LegalLayout";

export default function ServiceAgreement() {
  return (
    <LegalLayout title="Service Agreement" updated="February 6, 2026">
      <p>
        This Service Agreement is between you (the "Customer") and Foldora Laundry Inc. ("Foldora"). By ticking the
        acceptance checkbox in the booking flow, you agree to the following terms for that order.
      </p>
      <h2>1. Scope of service</h2>
      <p>
        Foldora will pick up your laundry at the address and window you selected, wash and dry it using the
        detergent option you chose (or the detergent you supply), fold it, and return it during the next drop-off window
        (or the same day for Express).
      </p>
      <h2>2. Preparation</h2>
      <ul>
        <li>Sort items you do not want washed together; place delicates in a mesh bag.</li>
        <li>Empty pockets — we are not responsible for money, jewellery, or items left in garments.</li>
        <li>Flag stains or special handling in the order notes.</li>
      </ul>
      <h2>3. Weight &amp; overages</h2>
      <p>
        Weight will be measured on pickup. If the actual weight exceeds the estimated weight, the additional lbs will be
        charged at $2/lb and reflected on the final invoice.
      </p>
      <h2>4. Turnaround</h2>
      <ul>
        <li>Standard: dropped off on the next scheduled drop-off day (Tue/Thu/Sat, 3–6 PM).</li>
        <li>Express: same-day return where the pickup is completed before 11 AM.</li>
      </ul>
      <h2>5. Access &amp; contactless</h2>
      <p>
        We support contactless pickup and delivery. Provide clear pickup / drop-off instructions in the notes field.
      </p>
      <h2>6. Damage &amp; liability</h2>
      <p>
        Our liability is limited to ten (10) times the invoice amount of the affected item(s), capped at CAD $250 per order,
        as described in the Damage Policy.
      </p>
      <h2>7. Acceptance record</h2>
      <p>
        When you tick the acceptance checkbox at checkout, we record your user ID, the timestamp, the Order ID, and the
        version of this Agreement. That record is your signature on this order.
      </p>
    </LegalLayout>
  );
}
